export default __webpack_public_path__ + "static/media/PBLC-1.dddfa651.jpeg";